import React, { useEffect, useState } from 'react';
import ShopifyBuyButton from './ShopifyBuyButton';
import { getShopifySettings } from '../lib/shopifyClient';

/**
 * AdSlotBuyButton — Shopify Buy Button for an ad-slot placement on the
 * /advertise page. Advertisers pay for the placement via Shopify checkout
 * (fast path). Admin follows up separately to collect the creative
 * (image / headline / CTA / destination URL / dates) via the existing
 * booking form. If the ad slot isn't mapped to Shopify yet, this returns
 * null so the caller falls back to the legacy "Book This" form flow.
 */
const adSlotButtonOptions = {
  product: {
    contents: { img: false, title: false, price: false, options: false, description: false, button: true },
    styles: {
      product: { 'max-width': '100%', 'margin': '0' },
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        'font-family': 'Outfit, sans-serif',
        'font-weight': '600',
        'letter-spacing': '0.08em',
        'text-transform': 'uppercase',
        'padding': '10px 16px',
        'font-size': '13px',
        'border-radius': '4px',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
    text: { button: 'Buy Placement' },
  },
  modalProduct: {
    contents: { img: false, imgWithCarousel: true, button: false, buttonWithQuantity: true },
    styles: {
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
    text: { button: 'Add to cart' },
  },
  cart: {
    text: { total: 'Subtotal', button: 'Checkout' },
    styles: {
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
  },
};

const AdSlotBuyButton = ({ slot }) => {
  const [shop, setShop] = useState(null);
  useEffect(() => {
    let alive = true;
    getShopifySettings().then((s) => {
      if (alive) setShop(s);
    });
    return () => { alive = false; };
  }, []);

  if (!slot || !slot.shopify_product_id) return null;
  if (shop === null) return null;
  if (!shop.domain || !shop.token) return null;

  return (
    <div
      className="w-full mt-2"
      onClick={(e) => e.stopPropagation()}
      data-testid={`ad-slot-buy-${slot.placement}`}
    >
      <ShopifyBuyButton
        shopDomain={shop.domain}
        storefrontToken={shop.token}
        componentType="product"
        componentId={slot.shopify_product_id}
        options={adSlotButtonOptions}
      />
    </div>
  );
};

export default AdSlotBuyButton;
